import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router';
import tw from 'twin.macro';

import { PATH } from '@/Route';
import { ProductItemBox } from '@/components/product/ProductItem';
import { useProduct } from '@/hooks/queries/partner';

const ProductDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isError } = useProduct({ id: Number(id) });

  if (isError) {
    navigate(PATH.MARKETING_PRODUCT.INDEX, { replace: true });
    return null;
  }

  if (!data) {
    return null;
  }

  return (
    <section css={tw`flex flex-col gap-y-[32px] w-full`}>
      <ProductItemBox
        productId={data.id}
        url={data.bannerImageUrl}
        name={data.name}
        summary={data.summary}
        price={data.price}
        discountPrice={data.discountPrice}
        useApplyButton
      />
      <div
        className="rich-content"
        css={tw`max-w-[1080px]`}
        dangerouslySetInnerHTML={{
          __html: data.description,
        }}
      />
      <div css={tw`flex justify-center items-center gap-x-[8px]`}>
        <Button
          onClick={() => {
            navigate(PATH.MARKETING_PRODUCT.INDEX);
          }}
        >
          목록으로
        </Button>
        <Button
          type="primary"
          onClick={() => {
            navigate(PATH.MARKETING_PRODUCT.ORDER, {
              state: {
                ...data,
              },
            });
          }}
        >
          신청하기
        </Button>
      </div>
    </section>
  );
};

export default ProductDetail;
